// extracted by mini-css-extract-plugin
export default {"HeaderFitContent":"HeaderFitContent_OHZFJ","h1":"h1_YKfE_","h2":"h2_stur4","h3":"h3_OSNT_","h4":"h4_ZRXNW","h5":"h5_cCYpX","h6":"h6_F0yhy"};